// extracted by mini-css-extract-plugin
export default {"loading_wrapper":"Loading_loading_wrapper__9LIV6"};